import type { MdOverride, MdOverrides } from './mdAst.js'

const tag = (name: string): MdOverride => ({ component: name })

/** Standard HTML tags always passed to md2ast allowlist. */
export const defaultHtmlOverrides: MdOverrides = {
  h1: tag('h1'),
  h2: tag('h2'),
  h3: tag('h3'),
  h4: tag('h4'),
  h5: tag('h5'),
  h6: tag('h6'),
  p: tag('p'),
  span: tag('span'),
  strong: tag('strong'),
  em: tag('em'),
  code: tag('code'),
  pre: tag('pre'),
  del: tag('del'),
  ins: tag('ins'),
  div: tag('div'),
  blockquote: tag('blockquote'),
  hr: tag('hr'),
  br: tag('br'),
  img: tag('img'),
  a: tag('a'),
  ul: tag('ul'),
  ol: tag('ol'),
  li: tag('li'),
  table: tag('table'),
  thead: tag('thead'),
  tbody: tag('tbody'),
  tr: tag('tr'),
  th: tag('th'),
  td: tag('td'),
  sup: tag('sup'),
  figure: tag('figure'),
  figcaption: tag('figcaption'),
  iframe: tag('iframe'),
  video: tag('video'),
  audio: tag('audio'),
  source: tag('source'),
  math: tag('math'),
  annotation: tag('annotation'),
  semantics: tag('semantics'),
  mrow: tag('mrow'),
  mi: tag('mi'),
  mo: tag('mo'),
  mn: tag('mn'),
  msup: tag('msup'),
  msub: tag('msub'),
  mfrac: tag('mfrac'),
  mtext: tag('mtext'),
}
